import { render, staticRenderFns } from "./MamLeaderBoardTopROE.vue?vue&type=template&id=79567ce6&scoped=true"
import script from "./MamLeaderBoardTopROE.vue?vue&type=script&lang=js"
export * from "./MamLeaderBoardTopROE.vue?vue&type=script&lang=js"
import style0 from "./MamLeaderBoardTopROE.vue?vue&type=style&index=0&id=79567ce6&prod&lang=scss&scoped=true"
import style1 from "./MamLeaderBoardTopROE.vue?vue&type=style&index=1&id=79567ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79567ce6",
  null
  
)

export default component.exports